import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';
import { OAuthPlatform } from 'src/secret-menu/sharepoint/types';

type CreateRemoteDocsConnectionInput = {
  authCode: string;
  state: string;
  platform: OAuthPlatform;
};

export const useCreateRemoteDocsConnectionMutation = () => {
  const queryClient = useQueryClient();

  const {
    mutateAsync,
    error,
    isPending: isLoading,
  } = useMutation<{ data: unknown }, Error, CreateRemoteDocsConnectionInput>({
    mutationFn: (input: CreateRemoteDocsConnectionInput) =>
      api.post('remote-docs-connections', input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['remote-docs-connections'] });
    },
  });

  const createRemoteDocsConnection = async (
    input: CreateRemoteDocsConnectionInput,
  ): Promise<void> => {
    await mutateAsync(input);
  };

  return {
    createRemoteDocsConnection,
    isLoading,
    error,
  };
};
